<template>
	<SubBarGlobal :currentCrumb="currentCrumb">
		<div class="dF aC" style="gap: 30px" v-if="routeConfig">
			<a-input placeholder="Search here..." v-model="search" allowClear style="width: 250px;" size="large">
				<a-icon slot="prefix" type="search" />
			</a-input>
			<a-button v-if="canCreate" type="primary" icon="plus" @click="createNew(routeConfig.path)" size="large">
				{{ routeConfig.buttonText }}
			</a-button>
		</div>
	</SubBarGlobal>
</template>

<script>
import SubBarGlobal from 'bh-mod/components/layout/SubBarGlobal'
import aiPermissionsMixin from '@/mixins/aiPermissionsMixin'

export default {
	mixins: [aiPermissionsMixin],
	components: { SubBarGlobal },
	computed: {
		instance() {
			return this.$store.state.instance
		},
		currentCrumb() {
			return this.$route.meta.crumbName;
		},
		search: {
			get() {
				return this.$store.state.appData.searchFilter;
			},
			set(value) {
				this.$store.commit('UPDATE_SEARCH', value);
			},
		},

		routeConfig() {
			const routeConfigs = {
				'/': {
					buttonText: 'CREATE AN AGENT',
					itemName: 'an agent',
					path: '/agent/new'
				},
				'/knowledgeBase': {
					buttonText: 'CREATE A KNOWLEDGE BASE',
					itemName: 'a knowledge base',
					path: '/knowledgeBase/new'
				}
			};
			return routeConfigs[this.$route.path];
		},
	},
	methods: {
		createNew(path) {
			if (!this.canCreate) {
				this.$message.error('You do not have permission to create new ' + this.routeConfig.itemName);
				return;
			}
			if (path === '/knowledgeBase/new') {
				this.$store.commit('SET_KNOWLEDGE_BASE_MODAL', true);
				return;
			}
			this.$router.push(path);
		},
		gotoSettings() {
			this.$router.push("/settings");
		},
	},
}
</script>
